<ng-container *transloco="let t">

  @if(service.working()) {
  <div class="absolute inset-0 z-30 flex items-center justify-center ">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>
  }

  @if(showFields()) {
  <div class="h-full flex flex-col px-1">

    <div class="flex items-center py-2  gap-3">
      <span class="text-xl font-semibold tracking-tight leading-tight truncate flex-1">{{t('Fields')}}</span>
      <button mat-icon-button [disabled]="service.working()" (click)="showFields.set(!showFields())">
        <i class="iconify text-2xl opacity-80" data-icon="solar:alt-arrow-left-linear"></i>
      </button>
    </div>

    <div class="my-2">
      <div class="search-input-wrapper">
        <i class="iconify size-4.5! opacity-80" data-icon="mdi-light:magnify"></i>
        <input [(ngModel)]="searchTerm" autocomplete="off" [placeholder]="t('Search')" />
      </div>
    </div>

    <mat-nav-list>
      @for(item of filteredFeatureFields(); track item.key) {
      <mat-list-item role="listitem" (click)="selectField(item)" [matTooltip]="item.label" matTooltipPosition="left"
        [matTooltipShowDelay]="500" class="my-0.5 gap-2 items-center">
        <span matListItemIcon class="me-0! flex flex-row items-center self-stretch justify-center">
          <i class="iconify text-xl opacity-80" [attr.data-icon]="item?.icon ?? 'solar:filter-outline'"></i>
        </span>
        <span matListItemTitle class="font-normal text-sm"> {{ item.label }} </span>
      </mat-list-item>
      }
    </mat-nav-list>
  </div>
  }
  @if(!showFields() && service.model() !== null) {
  @if(service.model(); as model) {
  <div class="flex flex-row items-center gap-2 py-2 px-1">
    <!-- <button mat-icon-button class="block lg:hidden!" (click)="close()">
                <mat-icon>arrow_back</mat-icon>
              </button> -->
    <h5 class="flex flex-1 text-xl font-semibold tracking-tight leading-tight truncate">{{ t('Filters') }}</h5>


    <!-- <div class="flex flex-row items-center gap-1"> -->
      @if(editMode()) {
            <button mat-flat-button color="primary" [disabled]="service.working()" (click)="service.save()">
                  {{ t('Save') }}
                </button>
      }



    <button mat-icon-button [matMenuTriggerFor]="menu1">
      <i class="iconify scale-80! opacity-80" data-icon="mdi:dots-vertical"></i>
    </button>

    <!-- <button mat-icon-button [disabled]="service.working()" (click)="close()" class="hidden! lg:block!">
                  <i-tabler name="x" class="size-5! flex"></i-tabler>
                </button> -->

    <mat-menu #menu1="matMenu" class="cardWithShadow">
      <button mat-menu-item [disabled]="service.working()" (click)="showFields.set(!showFields())">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:add-square-outline"></i>
          <span>{{ t('Add Filter') }}</span>
        </div>
      </button>

      <button mat-menu-item [disabled]="service.working()" (click)="clearFields()">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:eraser-linear"></i>
          <span>{{ t('Clear Filters') }}</span>
        </div>
      </button>

      <button mat-menu-item [disabled]="service.working()" (click)="editMode.set(!editMode())">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:pen-new-square-linear"></i>
          <span>{{ t('Edit') }}</span>
        </div>
      </button>


      <button mat-menu-item [disabled]="service.working()" (click)="removeAllFields()">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:trash-bin-2-linear"></i>
          <span>{{ t('Remove All Filters') }}</span>
        </div>
      </button>
    </mat-menu>
    <!-- </div> -->
  </div>

  <div class="flex flex-col gap-4" cdkDropList [cdkDropListDisabled]="!editMode()"
    (cdkDropListDropped)="reorderFields($event)">
    @for (item of service.model()?.fields ?? []; track item.key) {
    <div class="col-span-12" cdkDrag [cdkDragDisabled]="!editMode()" [class.hide-drag-handle]="!editMode()">
      @if (item.type === 'date') {
      <app-date-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)"
        (removed)="removeField($index)"></app-date-filter>
      } @else if (item.type === 'datetime') {
      <app-datetime-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)"
        (removed)="removeField($index)"></app-datetime-filter>
      } @else if (item.type === 'string') {
      <app-string-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)"
        (removed)="removeField($index)"></app-string-filter>
      } @else if (item.type === 'int' || item.type === 'long' || item.type === 'short' ) {
      <app-int-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)"
        (removed)="removeField($index)"></app-int-filter>
      } @else if (item.type === 'decimal' || item.type === 'double' || item.type === 'float') {
      <app-decimal-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)"
        (removed)="removeField($index)"></app-decimal-filter>
      } @else if (item.type === 'guid') {
      <app-guid-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)"
        (removed)="removeField($index)"></app-guid-filter>
      } @else if (item.type === 'bool') {
      <app-bool-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)"
        (removed)="removeField($index)"></app-bool-filter>
      } @else if (item.type === 'select_list') {
      <app-list-filter [ngModel]="item" (ngModelChange)="updateField($index, $event)" (removed)="removeField($index)"
        [allowRemoveItem]="editMode()"></app-list-filter>
      } @else {

      }
    </div>
    }
  </div>
  }
  }

</ng-container>
